<template>
	<div class="accept-orders">
		<modalRating ref="modalRating"></modalRating>
		<v-col class="pt-5">
			<div>
				<v-row>
					<v-col cols="12" md="2" class="py-0 pr-md-0">
						<profile-menu></profile-menu>
					</v-col>
					<v-col cols="12" md="10" class="pl-md-5 py-0 mt-5 mt-md-0">
						<div class="pb-4">
							<v-card outlined elevation="0" class="py-3 rounded-lg">
								<v-row class="px-3">
									<v-col class="py-1 text-body-2 my-auto">
										<span class="font-weight-bold">Rincian Transaksi</span>
									</v-col>
									<v-col class="py-1 text-right">
										<span class="text-uppercase text-body-2 font-weight-bold d-none d-md-inline-block">No. Transaksi</span>
										<span class="pl-1 text-uppercase text-body-2 font-weight-bold">2292179817</span>
									</v-col>
								</v-row>
								<div class="px-3 py-2"><v-divider></v-divider></div>
								<v-row class="px-3">
									<v-col cols="12">
										<div class="pt-3 pb-5 status-transaction-frame">
											<div class="w-sm-230-pct d-flex justify-center">
												<div>
													<img width="55" height="55" src="/assets/icons/pesanan-dibuat.svg">
												</div>
												<div class="my-auto green-line"></div>
												<div>
													<img width="55" height="55" src="/assets/icons/dibayar.svg">
												</div>
												<div class="my-auto green-line"></div>
												<div>
													<img width="55" height="55" src="/assets/icons/pesanan-dikirimkan.svg">
												</div>
												<div class="my-auto green-line"></div>
												<div>
													<img width="55" height="55" src="/assets/icons/sampai-tujuan.svg">
												</div>
												<div class="my-auto green-line"></div>
												<div>
													<img width="55" height="55" src="/assets/icons/pesanan-dinilai.svg">
												</div>
											</div>
											<div class="w-sm-230-pct d-flex justify-center">
												<div class="pt-2 px-1">
													<div class="w-9-rem text-center">
														<div class="font-size-13 grey--text text--darken-1">Pesanan Dibuat</div>
														<div class="font-size-13 font-weight-bold">30 Sep 2020</div>
														<div class="font-size-13 font-weight-bold">12:14</div>
													</div>
												</div>
												<div class="pt-2 pr-1">
													<div class="w-9-rem text-center">
														<div class="font-size-13 grey--text text--darken-1">Dibayar</div>
														<div class="font-size-13 font-weight-bold">30 Sep 2020</div>
														<div class="font-size-13 font-weight-bold">12:14</div>
													</div>
												</div>
												<div class="pt-2 px-1">
													<div class="w-9-rem text-center">
														<div class="font-size-13 grey--text text--darken-1">Pesanan Dikirimkan</div>
														<div class="font-size-13 font-weight-bold">30 Sep 2020</div>
														<div class="font-size-13 font-weight-bold">12:14</div>
													</div>
												</div>
												<div class="pt-2 px-1">
													<div class="w-9-rem text-center">
														<div class="font-size-13 grey--text text--darken-1">Sampai Tujuan</div>
														<div class="font-size-13 font-weight-bold">30 Sep 2020</div>
														<div class="font-size-13 font-weight-bold">12:14</div>
													</div>
												</div>
												<div class="pt-2">
													<div class="w-9-rem text-center">
														<div class="font-size-13 grey--text text--darken-1">Pesanan Dinilai</div>
														<div class="font-size-13 font-weight-bold">30 Sep 2020</div>
														<div class="font-size-13 font-weight-bold">12:14</div>
													</div>
												</div>
											</div>
										</div>
									</v-col>
								</v-row>
								<div class="px-3 py-5"><v-divider></v-divider></div>
								<v-row class="pl-3 pl-md-5 pr-3 py-3">
									<v-col cols="12" md="8" class="pl-3 pl-md-5 py-0 text-body-2">
										<div class="text-body-2 font-weight-bold">Alamat Pengiriman</div>
										<div class="pt-3">
											<div class="font-size-13 grey--text text--darken-1">Nama Penerima</div>
											<div class="text-body-2 font-weight-bold">Isa</div>
										</div>
										<div class="pt-3">
											<div class="font-size-13 grey--text text--darken-1">Nomor Handphone</div>
											<div class="text-body-2 font-weight-bold">0123456789</div>
										</div>
										<div class="pt-3">
											<div class="font-size-13 grey--text text--darken-1">Alamat</div>
											<div class="text-body-2">Jl. Siratal Mustaqim</div>
										</div>
									</v-col>
									<v-col cols="12" md="4" class="my-auto text-center text-md-right">
										<v-btn depressed height="45" block color="primary" class="mt-1 rounded-lg">
											<div class="font-weight-bold font-size-13">Pesanan Diterima</div>
										</v-btn>
										<v-btn outlined height="45" block color="primary" class="mt-3 rounded-lg">
											<div class="font-weight-bold font-size-13">Tampilkan Rincian Transaksi</div>
										</v-btn>
									</v-col>
								</v-row>
								<div class="px-3 py-5"><v-divider></v-divider></div>
								<v-row class="pl-3 pl-md-5 pr-3 pt-5">
									<v-col cols="12" class="pl-3 pl-md-5 py-0 text-body-2">
										<div class="text-body-2 font-weight-bold">Daftar Pembelian</div>
									</v-col>
									<v-col cols="12" class="pl-3 pl-md-5 pb-1">
										<v-card outlined class="rounded-lg">
											<v-row class="px-3">
												<v-col md="6">
													<div class="font-size-13 grey--text text--darken-1">Nama Store</div>
													<div class="font-size-13 font-weight-bold">Saber Store</div>
												</v-col>
												<v-col md="6" class="my-auto text-right">
													<v-btn text color="primary" class="px-0">
														<v-icon>mdi-chat-processing-outline</v-icon>
														<div class="pl-sm-1 font-size-13 text-capitalize font-weight-bold">Kirim Pesan</div>
													</v-btn>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
									<v-col cols="12" class="py-0 pl-3 pl-md-5">
										<v-row>
											<v-col cols="12" md="9">
												<v-row v-for="i in 2" :key="i">
													<v-col cols="4" sm="2" md="2" lg="2" class="pt-0 pb-2">
														<v-card outlined class="rounded-lg">
															<div class="pa-1">
																<v-img class="rounded-lg mx-auto" width="70" height="70" src="/assets/product/swiss-clock.png"></v-img>
															</div>
														</v-card>
													</v-col>
													<v-col cols="8" md="6" class="pl-2 pt-0 pt-md-1">
														<div class="text-body-2">Swiss Clock bcia vuewohv ovehwovhwo ovehwouvhw</div>
														<div class="pt-1 font-size-13 grey--text text--darken-1">Jumlah : 1</div>
														<div class="pt-1 font-size-13 grey--text text--darken-1">Berat : 1kg</div>
													</v-col>
													<v-col cols="12" md="4" class="pt-0 pt-md-3 my-auto">
														<div class="text-body-2 font-weight-bold">Rp 30.000.000</div>
													</v-col>
												</v-row>
											</v-col>
											<v-col cols="12" md="3" class="pt-1 pt-md-3 my-auto">
												<div>
													<div class="font-size-13 grey--text text--darken-1">Jasa Pengiriman</div>
													<div class="font-size-13 font-weight-bold">JNE REG</div>
												</div>
												<div class="pt-4">
													<div class="font-size-13 grey--text text--darken-1">No Resi</div>
													<div class="font-size-13 font-weight-bold">07654787986754</div>
												</div>
												<div class="pt-4">
													<div class="font-size-13 grey--text text--darken-1">Estimasi Barang Sampai</div>
													<div class="font-size-13 font-weight-bold">Jumat, 2 Oktober 2020</div>
												</div>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<!-- <div class="pt-5 px-3">
									<v-btn large depressed color="primary" class="text-body-2 font-weight-bold" @click="giveRating">Nilai Product</v-btn>
								</div> -->
							</v-card>
						</div>
					</v-col>
				</v-row>
			</div>
		</v-col>
	</div>
</template>

<script>
import ProfileMenu from '@/components/layout/store/ProfileMenu';
import modalRating from '@/views/store/profile/ModalRating'

export default {
	components: {
		ProfileMenu, modalRating
	},
	methods : {
		giveRating() {
			this.$refs.modalRating.modalShow();
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Terima Pesanan');
	}
};
</script>